import { createStore } from '@cobuildlab/react-simple-state';
import { PlanDetailsTabs } from './plan-types';

export const plansFilterStore = createStore<{
  status: string;
  isPremium: string;
}>({
  initialValue: {
    status: 'all',
    isPremium: 'all',
  },
});

export const plansSteps =
  createStore<PlanDetailsTabs>({
    initialValue: PlanDetailsTabs.DETAILS,
  });
